document.addEventListener('DOMContentLoaded', () => {
  const currentPathname = window.location.pathname;
  const timerContainer = document.getElementById('_a-countdown-timer');
  
  if (currentPathname.includes('/products')) {
    setTimeout(() => {
      const container = document.getElementById('_a-end-date');
      const productContainer = document.querySelector('product-info');
      if (productContainer.classList.contains('hide-auction')){
        if (container?.textContent.includes('Fecha de finalización:') && !timerContainer.textContent.includes('La subasta ha terminado')) {
            container.textContent = container?.textContent.replace(/Fecha de finalización:/, 'Fecha de Inicio:');
        }
      }
    }, 800);
  }
});